import React from 'react';
import PropTypes from 'prop-types';

import Messages from '../../../fragments/messages';
import ValidateDialog from '../../../../components/validate-dialog';

import SuscSummary from './susc-summary';


export default class DialogPrompt extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    showDialog: PropTypes.bool.isRequired,
    showSubmit: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const {rawDataCollection} = this.props;

    const messages = rawDataCollection.messages(
      'rawSuscResults', true, false, false);
    const noMessage = (messages.length === 0);

    const {seqType} = rawDataCollection;
    const isClinial = (!seqType || seqType === 'ClinicalList');

    return (
      <ValidateDialog {...this.props}>
        <SuscSummary rawDataCollection={rawDataCollection} />
        {noMessage?
        'No susceptibility result error was found.' :
        <Messages
         messages={messages}
         noIndent
         scrollable
        />
        }
        {isClinial?
          <div>
            Only clinial sequence with phenotype results will be updated.
          </div>:
        null}
      </ValidateDialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/gtable/dialog-prompt.js